import styled from 'styled-components';

export const Wrapper = styled.div``;

export const FormWrapper = styled.div`
    margin-bottom: 16px;
    max-width: 800px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
`;
